import { Controller } from '@hotwired/stimulus'

import CountryData from '../shared/country_data'

export default class extends Controller {
  static targets = ['country', 'state']
  static values = { initialState: String }

  connect() {
    if (!(this.hasCountryTarget && this.hasStateTarget)) return

    this.populateStates(this.countryTarget.value, this.initialStateValue)
  }

  onCountryChange() {
    this.populateStates(this.countryTarget.value, '')
  }

  populateStates(countryCode, selectedCode) {
    if (!countryCode) {
      this.clearStates()
      return
    }

    // Country options on this form are English-only (country_options in ProfilesController); match that.
    CountryData.countryStates(countryCode, 'en').then(states => {
      if (!states || states.length === 0) {
        this.clearStates()
        return
      }

      this.stateTarget.innerHTML = ''
      this.stateTarget.appendChild(new Option('', ''))
      states.forEach(state => {
        this.stateTarget.appendChild(new Option(state.name || state.code, state.code))
      })
      // Stored customer state values are inconsistent (some rows hold the ISO code,
      // others the full name) - matching name as a fallback covers both until the
      // data is normalized.
      const match = states.find(state =>
        state.code === selectedCode ||
        (state.name && state.name.toLowerCase() === String(selectedCode).toLowerCase()))
      this.stateTarget.value = match ? match.code : ''
      this.stateTarget.disabled = false
    })
  }

  clearStates() {
    this.stateTarget.innerHTML = ''
    this.stateTarget.appendChild(new Option('', ''))
    this.stateTarget.disabled = true
  }
}
